import { render, staticRenderFns } from "./addSlice.vue?vue&type=template&id=1b43e6c1&scoped=true"
import script from "./addSlice.vue?vue&type=script&lang=js"
export * from "./addSlice.vue?vue&type=script&lang=js"
import style0 from "./addSlice.vue?vue&type=style&index=0&id=1b43e6c1&prod&lang=scss&scoped=true"
import style1 from "./addSlice.vue?vue&type=style&index=1&id=1b43e6c1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b43e6c1",
  null
  
)

export default component.exports